import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BenchmarksComponent} from './benchmarks.component';
import {RouterModule} from '@angular/router';
import {BenchmarkService} from './benchmarks.service';
import {HelperModule} from '../../../helper/helper.module';
import {FormsModule} from '@angular/forms';
import {
  AverageComponent,
  PercentUsageComponent,
  UserSessionComponent,
  LicenseUserComponent,
  DenialFrequencyComponent
} from  './all.benchmarks.component';

import {HttpClientModule, HttpClient} from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    HelperModule,
    FormsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  declarations: [BenchmarksComponent, AverageComponent, DenialFrequencyComponent, LicenseUserComponent, UserSessionComponent, PercentUsageComponent],
  providers: [BenchmarkService]
})
export class BenchmarksModule {
}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/reports/myReports/benchmarks/benchmarks.module.ts